"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This component was created in order to add the aria-label attribute which is used
 * in the automation tests for selecting the necessary option value
 */
var Option = function Option(_ref) {
  var children = _ref.children,
    innerProps = _ref.innerProps,
    isSelected = _ref.isSelected,
    isFocused = _ref.isFocused,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])({
      'select-component__option': true,
      'select-component__option--is-selected': isSelected,
      'select-component__option--is-focused': isFocused,
      'select-component__option--is-disabled': isDisabled
    })
  }, innerProps, {
    "aria-label": children
  }), children);
};
Option.defaultProps = {
  isDisabled: false,
  children: null
};
Option.propTypes = {
  children: _propTypes["default"].node,
  innerProps: _propTypes["default"].shape({}).isRequired,
  isSelected: _propTypes["default"].bool.isRequired,
  isFocused: _propTypes["default"].bool.isRequired,
  isDisabled: _propTypes["default"].bool
};
Option.__docgenInfo = {
  "description": "This component was created in order to add the aria-label attribute which is used\r\nin the automation tests for selecting the necessary option value",
  "methods": [],
  "displayName": "Option",
  "props": {
    "isDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "innerProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "isSelected": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "isFocused": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    }
  }
};
var _default = Option;
exports["default"] = _default;